import { createI18n } from 'vue-i18n';
import de from './de.json';

const messages = {
    de
};

export const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages,
    globalInjection: true
});